var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenQuoIcon = function SvgOpenQuoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.026 12.514a7.4 7.4 0 0 1-.546 2.942 7.6 7.6 0 0 1-1.554 2.388 7.2 7.2 0 0 1-2.267 1.62 6.2 6.2 0 0 1-2.73.533q-3.003 0-4.976-2.174Q0 15.648 0 12.258q0-4.306 3.255-7.866Q6.53.83 11.359 0l.378.256q-1.365.81-2.288 2.345-.903 1.492-1.03 3.112 5.607 1.685 5.607 6.801m17.973 0a7.4 7.4 0 0 1-.546 2.942 7.6 7.6 0 0 1-1.553 2.388 7.2 7.2 0 0 1-2.268 1.62 6.2 6.2 0 0 1-2.73.533q-3.002 0-4.976-2.174-1.953-2.175-1.953-5.565 0-4.306 3.255-7.866Q24.503.83 29.333 0l.378.256q-1.365.81-2.29 2.345-.902 1.492-1.028 3.112Q32 7.398 32 12.514"
  })));
};
export default SvgOpenQuoIcon;